import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import base64js from "base64-js";
import { ProductContext } from "../../context/ProductContext";

interface ProductData {
  photo: string; // ✅ Changed from `string[]` to `string`
}

const Scanner = () => {
  const [productData, setProductData] = useState<ProductData | null>(null);
  const [isAuthentic, setIsAuthentic] = useState<boolean | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const imageFile = location.state?.imageUrl;
  const context = useContext(ProductContext);
  const productName = context?.product?.productName || "Product Name Not Available";

  const headingColor = context?.product?.headingColor || "#000000";

  useEffect(() => {
    const storedImage = localStorage.getItem("firstMediaImage");
    if (storedImage) {
      setProductData({ photo: storedImage });
    }
  }, []);
   const bgColor = context?.product?.bgColor;
   const bgGradient = context?.product?.bgGradient;
 
   const backgroundStyle = bgColor && bgColor !== "null"
     ? { backgroundColor: bgColor }
     : bgGradient?.start && bgGradient?.end
     ? { background: `linear-gradient(${bgGradient.direction || 'to right'}, ${bgGradient.start}, ${bgGradient.end})` }
     : {};

  useEffect(() => {
    const verifyProduct = async () => {
      if (!imageFile) {
        console.error("No image file received.");
        return;
      }

      const timeoutId = setTimeout(() => {
        setIsAuthentic(false);
      }, 25000);

      try {
        const response = await fetch(imageFile);
        const blob = await response.blob();

        const img = new Image();
        img.src = URL.createObjectURL(blob);
        img.crossOrigin = "anonymous";

        img.onload = async () => {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          if (!ctx) {
            console.error("Failed to get canvas context.");
            return;
          }

          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);

          canvas.toBlob(async (jpegBlob) => {
            if (!jpegBlob) {
              console.error("Failed to convert image to JPEG.");
              return;
            }

            const reader = new FileReader();
            reader.readAsArrayBuffer(jpegBlob);

            reader.onloadend = async () => {
              if (reader.result instanceof ArrayBuffer) {
                const binary = new Uint8Array(reader.result);
                const base64Image = base64js.fromByteArray(binary);

                const apiResponse = await fetch(
                  "https://0gcqgv2nn0.execute-api.ap-south-1.amazonaws.com/prod/check-image",
                  {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ image: base64Image }),
                  }
                );

                clearTimeout(timeoutId);
                const data = await apiResponse.json();
                const label = data?.classification_results?.[0]?.label;
                setIsAuthentic(label === "authentic");
              }
            };
          }, "image/jpeg");

          URL.revokeObjectURL(img.src);
        };
      } catch (error) {
        console.error("Error verifying product:", error);
        clearTimeout(timeoutId);
        setIsAuthentic(false);
      }
    };

    verifyProduct();
  }, [imageFile]);

  return (
    <div
      style={{
        width: "100%",
        height: "83vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        ...backgroundStyle
      }}

    >
      {isAuthentic === null && (
        <img
          src="/images/verify.gif"
          alt="Processing"
          style={{
            maxWidth: "300px",
            maxHeight: "300px",
          }}
        />
      )}

      {isAuthentic === true && (
        <div style={{ textAlign: "center", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center"}}>
          <img
            src="/images/success_green.gif"
            alt="Product Verified"
            style={{
              width: "250px",
              height: "250px",
            }}
          />
          <p
            style={{
              marginTop: "20px",
              fontSize: "24px",
              color: headingColor,
              fontWeight: "bold",
              textAlign: "center",
              backgroundColor: "rgb(70 142 220)",
              padding: "10px 20px",
              borderRadius: "8px",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            Your Product is Authentic
          </p>
          <p
            onClick={() => navigate(-1)}
            style={{
              marginTop: "20px",
              fontSize: "16px",
              color: "#007BFF",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            Verify More Products
          </p>

          {productData && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "15px",
                border: "1px solid #007BFF",
                borderRadius: "10px",
                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                width: "78%",
                marginTop:"20px"
              }}
            >
              <img
                src={productData.photo}
                alt="Product"
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "8px",
                  objectFit: "cover",
                  marginRight: "15px",
                }}
              />
              <p
                style={{
                  fontSize: "13px",
                  fontWeight: "bold",
                  color: headingColor,
                  margin: 0,
                }}
              >
                {productName}
              </p>
            </div>
          )}
        </div>
      )}

      {isAuthentic === false && (
        <div style={{ textAlign: "center", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center"}}>
          <p
            style={{
              fontSize: "22px",
              fontWeight: "bold",
              color: "red",
              marginBottom: "10px",
            }}
          >
            Data not found in our Records.
          </p>
          <img
            src="/images/wrong.gif"
            alt="Fake Product"
            style={{
              width: "250px",
              height: "250px",
            }}
          />
          <p
            onClick={() => navigate(-1)}
            style={{
              marginTop: "20px",
              fontSize: "16px",
              color: "#007BFF",
              textDecoration: "underline",
              cursor: "pointer",
            }}
          >
            Please try again
          </p>
        </div>
      )}
    </div>
  );
};

export default Scanner;
